/* CONTEXT:START
Wave: 1
Status: partial
Stub-Type: mock-data
Dependencies: [existing admin components]
Risk-Level: high
Validation-Method: e2e-test
Performance-Target: <3s
Last-Updated: 2025-08-03
CONTEXT:END */

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Alert
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import WritingTenetsConfig from './WritingTenetsConfig';
import StakeholderEmailsConfig from './StakeholderEmailsConfig';
import JoeConfiguration from './JoeConfiguration';
import { PenholderAssignmentManager } from './PenholderAssignmentManager';
import { PenholderMetricsDashboard } from './PenholderMetricsDashboard';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const AdminDashboard: React.FC = () => {
  const { user } = useAuth();
  const [tabValue, setTabValue] = useState(0);

  if (!user?.isAdmin) {
    return (
      <Box>
        <Alert severity="error">
          Access denied. Admin privileges required.
        </Alert>
      </Box>
    );
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Admin Dashboard
      </Typography>
      
      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            aria-label="admin dashboard tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Penholder Management" id="admin-tab-0" aria-controls="admin-tabpanel-0" />
            <Tab label="Penholder Metrics" id="admin-tab-1" aria-controls="admin-tabpanel-1" />
            <Tab label="Writing Tenets" id="admin-tab-2" aria-controls="admin-tabpanel-2" />
            <Tab label="Stakeholder Emails" id="admin-tab-3" aria-controls="admin-tabpanel-3" />
            <Tab label="Joe Configuration" id="admin-tab-4" aria-controls="admin-tabpanel-4" />
          </Tabs>
        </Box>
        
        <TabPanel value={tabValue} index={0}>
          <PenholderAssignmentManager />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <PenholderMetricsDashboard />
        </TabPanel>
        
        <TabPanel value={tabValue} index={2}>
          <WritingTenetsConfig />
        </TabPanel>
        
        <TabPanel value={tabValue} index={3}>
          <StakeholderEmailsConfig />
        </TabPanel>
        
        <TabPanel value={tabValue} index={4}>
          <JoeConfiguration />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default AdminDashboard;